import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatArticleDate } from "../blogs/articleHelpers";
import { questionUrl } from "./questionHelpers";

export default function QuestionCardSideBar(props) {
  const Lng = localStorage.getItem("lang");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const url = questionUrl(props.question, Lng);

  function open(e) {
    e.preventDefault();
    navigate(url);
  }

  return (
    <li className="avc-qa-latest__item">
      <i className="far fa-question-circle" aria-hidden="true"></i>
      <div>
        <a href={url} onClick={open} className="avc-qa-latest__title" dir="auto">
          {props.question.title || t("blog_is_not_available")}
        </a>
        <time dateTime={props.question.createdAt}>
          {formatArticleDate(props.question.createdAt, Lng)}
        </time>
      </div>
    </li>
  );
}
